import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=c0f5393c&scoped=true&"
import script from "./CustomCard.ts?vue&type=script&lang=ts&"
export * from "./CustomCard.ts?vue&type=script&lang=ts&"
import style0 from "./CustomCard.scss?vue&type=style&index=0&id=c0f5393c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f5393c",
  null
  
)

export default component.exports